//imports
import { all } from 'redux-saga/effects';

import usersCreateUserSagas from 'Modules/pmUsers/.components/createEditUser/redux/saga';
import usersDeleteUserSagas from 'Modules/pmUsers/.components/deleteUser/redux/saga';
import usersResetPasswordUserSagas from 'Modules/pmUsers/.components/resetPassword/redux/saga';
import jiraSummarySagas from 'Modules/pmUsers/views/jiraSummary/redux/saga';
import forceLogoutSagas from 'Modules/pmUsers/.components/forceLogout/redux/saga';
import userDetailsSagas from 'Modules/pmUsers/views/jiraSummary/.components/userDetails/redux/saga';
//merge sagas
export default function* rootSaga() {
	yield all([
		usersCreateUserSagas(),
		usersDeleteUserSagas(),
		usersResetPasswordUserSagas(),
		jiraSummarySagas(),
		forceLogoutSagas(),
		userDetailsSagas(),
	]);
}
